import { Component} from '@angular/core';
import { Brand } from 'src/brands/brand';
import { Title } from "@angular/platform-browser";
import { environment } from './../environments/environment';
import { Client } from './generated-api-proxy';
import { Router, RoutesRecognized } from '@angular/router';
import { ActiveUserService } from './services/activeuser.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent { //implements AfterContentInit
  title = "Preventor";
  showNavbar = false;
  initialJwt: string | null = null

  constructor(
    private titleService: Title,
    private client: Client,
    private router: Router,
    private activeUser: ActiveUserService) {
    this.titleService.setTitle(Brand.brandTitle);
    this.showNavbar = environment.showNavbar;

    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        let initialJwt = event.state.root.children[0].params["jwt"];
        if (initialJwt) {
          this.activeUser.setActiveUserToken(decodeURIComponent(initialJwt));
        }
      }
    });
  }
}
